const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.sk-circle {
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
}

.sk-circle .sk-child {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.sk-circle .sk-child:before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #333;
  border-radius: 100%;
  -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
  animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
}

.sk-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  transform: rotate(30deg);
}

.sk-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  transform: rotate(60deg);
}

.sk-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

.sk-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  transform: rotate(120deg);
}

.sk-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
  -ms-transform: rotate(150deg);
  transform: rotate(150deg);
}

.sk-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.sk-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
  -ms-transform: rotate(210deg);
  transform: rotate(210deg);
}

.sk-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
  -ms-transform: rotate(240deg);
  transform: rotate(240deg);
}

.sk-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}

.sk-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
  -ms-transform: rotate(300deg);
  transform: rotate(300deg);
}

.sk-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
  transform: rotate(330deg);
}

.sk-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.sk-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.sk-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.sk-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

.sk-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}

.sk-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}

.sk-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}

.sk-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}

.sk-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}

.sk-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}

.sk-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}

@-webkit-keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
